import React from "react";

// Context
import { useState, useContext } from "react";

import UserContext from "../../../Context/UserContext";
// End Context

import "./Login.css";
// import Breadcrumb from '../../Layout/Breadcrumb/Breadcrumb';
// import Header from '../../Layout/Header/Header';
// import Footer from '../../Layout/Footer/Footer';
// import Nav from '../../Layout/Nav/Nav';
import LoginImage from "../../../Images/login.jpg";
import sitelogo from "../../../Images/logo.png";
import { Link } from "react-router-dom";

function Login() {
  // Context
  const { userIN, setUserIN } = useContext(UserContext);

  const userRoute = (e) => {
    e.preventDefault();
    setUserIN(true);
  };

  // End Context

  return (
    <div className="page-con-full">
      <div className="page-body">
        <div className="comb-sec login-sec">
          <div className="bg-body-tertiary min-vh-100XXX d-flex flex-row align-items-center">
            <div className="container">
              <div className="row justify-content-center">
                <div className="col-lg-8">
                  <div className="card-group d-block d-md-flex row">
                    <div className="card col-md-7 p-4 mb-0">
                      <div className="card-body">
                        {/* <img className="login-logo" src={sitelogo} alt="" /> */}
                        <h6 >WELCOME TO</h6>
                        <h2 className="mb-4">FIELD FORCE AUTOMATION</h2>
                        <h5 className="login-text">Log In</h5>
                        <div className="input-group mb-3">
                          {/* <span className="input-group-text">
                      <svg className="icon">
                        <use xlink:href="vendors/@coreui/icons/svg/free.svg#cil-user"></use>
                      </svg></span> */}
                          <input
                            className="form-control"
                            type="text"
                            placeholder="Username"
                          />
                        </div>
                        <div className="input-group mb-4">
                          {/* <span className="input-group-text">
                      <svg className="icon">
                        <use xlink:href="vendors/@coreui/icons/svg/free.svg#cil-lock-locked"></use>
                      </svg></span> */}
                          <input
                            className="form-control"
                            type="password"
                            placeholder="Password"
                          />
                        </div>
                        <div className="row">
                          <div className="col-6">
                            {/* <button  onClick={userRoute}>
                              user Authern
                            </button> */}
                            <Link
                              to="/dashboard"
                              className="btn btn-primary px-4"
                              type="button"
                            >
                              Login
                            </Link>
                          </div>
                          <div className="col-6 text-end">
                            <button
                              className="btn btn-link px-0 login-forgot-password"
                              type="button"
                            >
                              Forgot password?
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      className="card col-md-5 text-white bg-primary py-5 login-displya-img"
                      style={{ backgroundImage: `url(${LoginImage})` }}
                    >
                      <div className="card-body text-center">
                        {/* <div>
                    <h2>Sign up</h2>
                    <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p>
                    <button className="btn btn-lg btn-outline-light mt-3" type="button">Register Now!</button>
                  </div> */}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
export default Login;
